<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroPromocaoAgente />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroPromocaoAgente from "../Components/Cadastros/CadastroPromocaoAgente.vue";
export default {
  name: "RegisterPromoCorretor",
  components: {
    CadastroPromocaoAgente,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
